export default class MobileNavigationSearch {
    constructor() {
        this.input = document.querySelector('.js-search-input');

        if (!this.input) {
            return;
        }

        this.filterString = this.input.value.toUpperCase();
        this.itmes = document.querySelectorAll('.js-search-item');

        this.init();
    }

    init() {
        this.input.addEventListener('keyup', () => {
            setTimeout(() => {
                this.filterString = this.input.value.toUpperCase();

                if (this.input.value !== "") {
                    this.search();
                } else {
                    this.resetElements();
                }
            }, 100);
        });
    }

    search() {
        for (let i = 0; i < this.itmes.length; i++) {
            let current = this.itmes[i];
            let txtValue = current.textContent || current.innerText;
            if (txtValue.toUpperCase().indexOf(this.filterString) > -1) {
                current.classList.remove('search-inactive');
                current.classList.add('search-active');
            } else {
                current.classList.add('search-inactive');
                current.classList.remove('search-active');
            }

            if (current.parentNode.querySelectorAll('.js-search-item.search-active').length > 0) {
                current.classList.remove('search-inactive');
                current.classList.add('search-active');
            }
        }
    }

    resetElements() {
        for (let item of this.itmes) {
            item.classList.remove('search-inactive');
            item.classList.remove('search-active');
        }
    }

}
